(function($) {
  $('.tripple-nav').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  $('.compare-container').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          dots: true,
          initialSlide: 1
        }
      }
    ]
  });

  $('.quote-slider').on('init', function(event, slick){
    $('.slick-current').addClass('prev');
    $('.slick-current').next().next().addClass('next');
  });

  $('.quote-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  })
  .on('beforeChange', function(event, slick, currentSlide, nextSlide){
      // then let's do this before changing slides
  })
  .on('afterChange', function(event, slick, currentSlide, nextSlide){
      // finally let's do this after changing slides
  });


  $('.product-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }

    ]
  });

  $('.about-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });

})(jQuery);
